import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Error404 from "./components/Error404";
import Intro from "./components/Intro/Intro";

import Formulario from "./components/Formulario/Formulario";
import TagManager from "react-gtm-module";
import Slider from "./components/Slider";

const tagManagerArgs = {
  gtmId: "G-KJ90PKBGDS",
};

TagManager.initialize(tagManagerArgs);

function App() {
  window.dataLayer.push({
    event: "pageview",
  });
  return (
    <Router basename="/rangerexperience">
      <Switch>
        <Route exact path="/">
          <Header />
          <Slider />

          <Formulario />
          <Footer />
        </Route>

        <Route path="*">
          <Header bg="bgDark" />
          <Error404 />
          <Footer />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
